export function getHostByUrl(url) {
  try {
    if (typeof url !== 'string') return '';
    const urlObj = new URL(url);
    return urlObj.host;
  } catch (error) {
    console.error(error);
    return '';
  }
}
//# sourceMappingURL=url.js.map
